import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";

export const useNoIndex = () => {
  useEffect(() => {
    let m = document.head.querySelector('meta[name="robots"]');
    if (!m) {
      m = document.createElement("meta");
      m.name = "robots";
      document.head.appendChild(m);
    }
    const prev = m.content;
    m.content = "noindex, nofollow";
    return () => { m.content = prev || "index, follow"; };
  }, []);
};

export default function NotFound() {
  const { tr } = useLang();
  useNoIndex();
  useEffect(() => { document.title = tr("Page not found | Dr. Cora", "Página no encontrada | Dra. Cora"); }, [tr]);
  return (
    <section className="pt-48 pb-32 text-center px-5" data-testid="not-found-page">
      <p className="font-display text-7xl text-[#00C9B7] mb-4">404</p>
      <h1 className="font-display uppercase text-3xl mb-8">{tr("This page doesn't exist", "Esta página no existe")}</h1>
      <Link to="/" className="rounded-full bg-[#00C9B7] text-[#031312] px-7 py-4 text-xs font-bold uppercase tracking-widest" data-testid="not-found-home-btn">{tr("Back to home", "Volver al inicio")}</Link>
    </section>
  );
}
